import { DropdownMenu } from 'cpool-components/input/DropdownMenu';

export type AdviserOption = { disabled: boolean; label: string; value: string };

type Props = {
    'aria-labelledby': string;
    'data-testid': string;
    disabled: boolean;
    onSelect: (userId: string) => void;
    options: AdviserOption[];
    placeholder?: string;
    value?: string;
};

export const AdviserSelect: React.FC<Props> = ({ onSelect, ...props }) => (
    <DropdownMenu
        {...props}
        matchTriggerWidth
        onChange={(value: string | string[]) => {
            const id = Array.isArray(value) ? value[0] : value;
            if (id) onSelect(id);
        }}
        searchable
        triggerClassName="w-full"
    />
);
